var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.48 4.104h20.71a1.25 1.25 0 100-2.5H1.48a1.25 1.25 0 000 2.5zM22.19 20.834H1.49a1.25 1.25 0 000 2.5h20.7a1.25 1.25 0 000-2.5zM1.5 13.965c6.886.146 13.776.106 20.67-.12 1.61-.06 1.62-2.56 0-2.5-6.887.233-13.777.273-20.67.12a1.25 1.25 0 000 2.5z"
  })));
}
export default SvgMenu;